export default __webpack_public_path__ + "static/media/deliland-puju-icon.0107b703.png";